const commonMessages = {
  'common.button.create': '登録',
  'common.button.update': '更新',
  'common.button.add': '追加',
  'common.button.edit': '編集',
  'common.button.delete': '削除',
  'common.button.cancel': 'キャンセル',
  'common.button.back': '戻る',
  'common.button.editCancel': '編集内容を破棄',
  'common.button.clearSelections': '選択解除',
  'common.button.clear': 'クリア',
  'common.button.clear.target': '{target}をクリア',
  'common.label.required': '必須',
  'common.label.disabled': '削除済み',
  'common.label.noSelect': '選択なし',
  'common.label.all': '全て',
  'common.label.send': '送信',
  'common.label.attach': '添付',
  'common.label.item.tag': 'タグ',
  'common.option.default': '選択してください',
  'common.message.validation.lengthLeft': 'あと{count}文字',
  'common.message.validation.totalFileSize':
    '送信可能なファイルサイズの上限を超えています',
  'common.message.validation.extension': '{file}は送信できません',
  'common.message.search.result': '{count}件見つかりました',
  'common.placeholder': '{name}を入力してください',
  'common.placeholder.item.sentence': '文章',
  'common.placeholder.item.keyword': 'キーワード',
  'calendar.months': '["1","2","3","4","5","6","7","8","9","10","11","12"]',
  'clipboard.copy.success': 'クリップボードにコピーしました',
  'selectBox.allChecked.title': '全て選択する',
  'toolbar.group.title': 'グループ',
};

export default commonMessages;
